export default __webpack_public_path__ + "static/media/Ballroll_00336.0bcaab44.png";